<template>
  <v-card style="overflow: visible;" class="elevation-0">
    <v-toolbar flat color="white" density="compact">
      <v-text-field
          density="compact"
          class="reg-normal text-primary ml-5"
          base-color="border-tertiary"
          bg-color="secondary"
          color="primary"
          v-model="advanced_search.text_search"
          v-debounce:800ms.lock="showRecords"
          @click:clear="clearSearch('text_search')"
          hide-details
          single-line
          flat
          clearable
          prepend-inner-icon="mdi-magnify">
        <template #label>
          <span class="sm-normal text-subtle">{{ $store.getters.translate('search') }}</span>
        </template>
      </v-text-field>
      <v-autocomplete
          class="reg-normal text-primary ml-5"
          base-color="border-tertiary"
          bg-color="secondary"
          density="compact"
          v-model="advanced_search.root_asset_name"
          :items="advanced_search_models.root_asset_name"
          @update:model-value="showRecords"
          :return-object="false"
          hide-details
          single-line
          clearable>
        <template #label>
          <span class="sm-normal text-subtle">{{ $store.getters.translate('root_asset_name') }}</span>
        </template>
      </v-autocomplete>
      <v-spacer/>
      <div class="chip-container">
        <!--EQUIPMENT TYPES-->
        <base-action-button v-if="canShowEquipmentTypes" @action="$router.push('/equipmenttypes')">
          <template #prepend><PhGear style="vertical-align: middle; margin-right: 5px;" size="20"/></template>
          {{ $store.getters.translate("equipmenttypes") }}
        </base-action-button>
        <base-action-button v-if="canCreate" @action="$emit('create')">
          <template #prepend><PhPlus style="vertical-align: middle; margin-right: 5px;" size="20"/></template>
          {{ $store.getters.translate("create") }}
        </base-action-button>
      </div>
    </v-toolbar>
    <v-card-text>
      <BaseResizableColumns :forceHorizontal="true">
        <template #left>
          <v-card class="pa-5" rounded="xl" border="sm" variant="outlined">
            <!--eachDraggable temporary disabled because the user should provide the reason why he moved the equipment
            later FALSE should be replaced back with stat.data.type === 'article'-->
            <Draggable
                ref="tree"
                class="mtl-tree ma-5"
                :defaultOpen="false"
                v-model="records"
                :rootDroppable="false"
                :eachDraggable="() => false"
                :eachDroppable="(stat) => stat.data.type === 'tagnumber'"
                @after-drop="endDrag"
                indent="20"
                treeLine>
              <template #default="{ node, stat }">
                <div :class="selected_article && node.id === 'article-' + selected_article.id ? 'active-highlight' : ''" style="display: flex; align-items: center; width: 100%;">
                  <OpenIcon v-if="stat.children && stat.children.length" :open="stat.open" @click.native="stat.open = !stat.open"/>
                  <span v-if="node && node.type === 'article'" class="sm-normal text-primary ma-3" style="cursor: pointer; width: 100%;" @click.stop="getArticleInfo(node.id)">
                    {{ node.name }}
                  </span>
                  <span v-else class="text-primary ma-3" :class="stat.open ? 'sm-bold' : 'sm-normal'">
                    {{ node.name }}
                  </span>
                  <v-spacer/>
                  <v-menu v-if="node && node.type === 'article' && canDelete">
                    <template #activator="{ props }">
                      <v-btn elevation="0" icon variant="plain" v-bind="props">
                        <PhDotsThreeVertical size="24" weight="bold" style="cursor: pointer;"/>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item @click.stop="archive(node)">
                        <template #prepend><PhTrash size="24"/></template>
                        <v-list-item-title class="sm-normal link ml-2">{{ $store.getters.translate('delete') }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
              </template>
            </Draggable>
          </v-card>
        </template>
        <template #right>
          <v-card v-if="selected_article" class="pa-5 position-sticky top-0" rounded="xl" border="sm" variant="outlined" style="overflow:auto; height:90vh">
            <v-toolbar flat color="white" density="compact">
              <v-spacer/>
              <base-link-button @action="$router.push('/articles/' + selected_article.id)">
                <template #prepend><PhArrowSquareOut style="vertical-align: middle; margin-right: 5px;" size="20"/></template>
                {{ $store.getters.translate("article") }}
              </base-link-button>
            </v-toolbar>
            <v-carousel v-if="selected_article.files.find(item => item.content_type === 'image/png' || item.content_type === 'image/jpeg')" hide-delimiters>
              <v-carousel-item
                  v-for="(file, index) in selected_article.files.filter(item => item.content_type === 'image/png' || item.content_type === 'image/jpeg')"
                  :key="index"
                  :src="file.full_path"/>
            </v-carousel>
            <v-card-text>
              <v-text-field
                  density="default"
                  color="primary"
                  class="reg-normal mt-3"
                  variant="plain"
                  hide-details
                  readonly
                  persistent-placeholder
                  v-model="selected_article.name">
                <template #label>
                  <span class="sm-bold text-primary">{{ $store.getters.translate('name') }}</span>
                </template>
              </v-text-field>
              <v-text-field
                  density="default"
                  color="primary"
                  class="reg-normal mt-3"
                  variant="plain"
                  hide-details
                  readonly
                  persistent-placeholder
                  v-model="selected_article.last_inspection_date">
                <template #label>
                  <span class="sm-bold text-primary">{{ $store.getters.translate('last_inspection_date') }}</span>
                </template>
              </v-text-field>
              <v-text-field
                  density="default"
                  color="primary"
                  class="reg-normal mt-3"
                  variant="plain"
                  hide-details
                  readonly
                  persistent-placeholder
                  v-model="selected_article.last_modification_date">
                <template #label>
                  <span class="sm-bold text-primary">{{ $store.getters.translate('last_modification_date') }}</span>
                </template>
              </v-text-field>
              <v-text-field
                  v-if="selected_article.tag_number"
                  density="default"
                  color="primary"
                  class="reg-normal mt-3"
                  variant="plain"
                  hide-details
                  readonly
                  persistent-placeholder
                  v-model="selected_article.tag_number.name">
                <template #label>
                  <span class="sm-bold text-primary">{{ $store.getters.translate('tag_number_name') }}</span>
                </template>
              </v-text-field>
              <v-text-field
                  density="default"
                  color="primary"
                  class="reg-normal mt-3"
                  variant="plain"
                  hide-details
                  readonly
                  persistent-placeholder
                  v-model="selected_article.description">
                <template #label>
                  <span class="sm-bold text-primary">{{ $store.getters.translate('description') }}</span>
                </template>
              </v-text-field>
              <v-text-field
                  v-if="selected_article.brand"
                  density="default"
                  color="primary"
                  class="reg-normal mt-3"
                  variant="plain"
                  hide-details
                  readonly
                  persistent-placeholder
                  v-model="selected_article.brand.name">
                <template #label>
                  <span class="sm-bold text-primary">{{ $store.getters.translate('brand') }}</span>
                </template>
              </v-text-field>
              <v-text-field
                  density="default"
                  color="primary"
                  class="reg-normal mt-3"
                  variant="plain"
                  hide-details
                  readonly
                  persistent-placeholder
                  v-model="selected_article.type">
                <template #label>
                  <span class="sm-bold text-primary">{{ $store.getters.translate('type') }}</span>
                </template>
              </v-text-field>
              <v-text-field
                  density="default"
                  color="primary"
                  class="reg-normal mt-3"
                  variant="plain"
                  hide-details
                  readonly
                  persistent-placeholder
                  v-model="selected_article.model">
                <template #label>
                  <span class="sm-bold text-primary">{{ $store.getters.translate('model') }}</span>
                </template>
              </v-text-field>
              <v-text-field
                  density="default"
                  color="primary"
                  class="reg-normal mt-3"
                  variant="plain"
                  hide-details
                  readonly
                  persistent-placeholder
                  v-model="selected_article.model_details">
                <template #label>
                  <span class="sm-bold text-primary">{{ $store.getters.translate('model_details') }}</span>
                </template>
              </v-text-field>
              <v-text-field
                  density="default"
                  color="primary"
                  class="reg-normal mt-3"
                  variant="plain"
                  hide-details
                  readonly
                  persistent-placeholder
                  v-model="selected_article.serial_number">
                <template #label>
                  <span class="sm-bold text-primary">{{ $store.getters.translate('serial_number') }}</span>
                </template>
              </v-text-field>
              <v-text-field
                  density="default"
                  color="primary"
                  class="reg-normal mt-3"
                  variant="plain"
                  hide-details
                  readonly
                  persistent-placeholder
                  v-model="equipment_type_name">
                <template #label>
                  <span class="sm-bold text-primary">{{ $store.getters.translate('equipment_type_name') }}</span>
                </template>
              </v-text-field>
              <v-text-field
                  v-if="selected_article.tag_number && selected_article.tag_number.location"
                  density="default"
                  color="primary"
                  class="reg-normal mt-3"
                  variant="plain"
                  hide-details
                  readonly
                  persistent-placeholder
                  v-model="selected_article.tag_number.location.name">
                <template #label>
                  <span class="sm-bold text-primary">{{ $store.getters.translate('location_name') }}</span>
                </template>
              </v-text-field>
              <v-text-field
                  v-if="selected_article.application"
                  density="default"
                  color="primary"
                  class="reg-normal mt-3"
                  variant="plain"
                  hide-details
                  readonly
                  persistent-placeholder
                  v-model="selected_article.application.name">
                <template #label>
                  <span class="sm-bold text-primary">{{ $store.getters.translate('application_name') }}</span>
                </template>
              </v-text-field>
              <v-text-field
                  v-if="selected_article.markering"
                  density="default"
                  color="primary"
                  class="reg-normal mt-3"
                  variant="plain"
                  hide-details
                  readonly
                  persistent-placeholder
                  v-model="selected_article.markering.name">
                <template #label>
                  <span class="sm-bold text-primary">{{ $store.getters.translate('markering_name') }}</span>
                </template>
              </v-text-field>
              <v-text-field
                  density="default"
                  color="primary"
                  class="reg-normal mt-3"
                  variant="plain"
                  hide-details
                  readonly
                  persistent-placeholder
                  v-model="selected_article.ip_solids">
                <template #label>
                  <span class="sm-bold text-primary">{{ $store.getters.translate('ip_solids') }}</span>
                </template>
              </v-text-field>
              <v-text-field
                  density="default"
                  color="primary"
                  class="reg-normal mt-3"
                  variant="plain"
                  hide-details
                  readonly
                  persistent-placeholder
                  v-model="selected_article.ip_water">
                <template #label>
                  <span class="sm-bold text-primary">{{ $store.getters.translate('ip_water') }}</span>
                </template>
              </v-text-field>
              <v-text-field
                  density="default"
                  color="primary"
                  class="reg-normal mt-3"
                  variant="plain"
                  hide-details
                  readonly
                  persistent-placeholder
                  v-model="line_voltage_name">
                <template #label>
                  <span class="sm-bold text-primary">{{ $store.getters.translate('line_voltage_name') }}</span>
                </template>
              </v-text-field>
              <v-text-field
                  density="default"
                  color="primary"
                  class="reg-normal mt-3"
                  variant="plain"
                  hide-details
                  readonly
                  persistent-placeholder
                  v-model="selected_article.power">
                <template #label>
                  <span class="sm-bold text-primary">{{ $store.getters.translate('power') }}</span>
                </template>
              </v-text-field>
              <v-text-field
                  density="default"
                  color="primary"
                  class="reg-normal mt-3"
                  variant="plain"
                  hide-details
                  readonly
                  persistent-placeholder
                  v-model="selected_article.nominal_current">
                <template #label>
                  <span class="sm-bold text-primary">{{ $store.getters.translate('nominal_current') }}</span>
                </template>
              </v-text-field>
              <v-text-field
                  density="default"
                  color="primary"
                  class="reg-normal mt-3"
                  variant="plain"
                  hide-details
                  readonly
                  persistent-placeholder
                  v-model="selected_article.ambient_temperature_low">
                <template #label>
                  <span class="sm-bold text-primary">{{ $store.getters.translate('ambient_temperature_low') }}</span>
                </template>
              </v-text-field>
              <v-text-field
                  density="default"
                  color="primary"
                  class="reg-normal mt-3"
                  variant="plain"
                  hide-details
                  readonly
                  persistent-placeholder
                  v-model="selected_article.ambient_temperature_high">
                <template #label>
                  <span class="sm-bold text-primary">{{ $store.getters.translate('ambient_temperature_high') }}</span>
                </template>
              </v-text-field>
              <v-text-field
                  density="default"
                  color="primary"
                  class="reg-normal mt-3"
                  variant="plain"
                  hide-details
                  readonly
                  persistent-placeholder
                  v-model="selected_article.year_of_installation">
                <template #label>
                  <span class="sm-bold text-primary">{{ $store.getters.translate('year_of_installation') }}</span>
                </template>
              </v-text-field>
              <v-text-field
                  density="default"
                  color="primary"
                  class="reg-normal mt-3"
                  variant="plain"
                  hide-details
                  readonly
                  persistent-placeholder
                  v-model="selected_article.year_of_fabrication">
                <template #label>
                  <span class="sm-bold text-primary">{{ $store.getters.translate('year_of_fabrication') }}</span>
                </template>
              </v-text-field>
              <v-text-field
                  density="default"
                  color="primary"
                  class="reg-normal mt-3"
                  variant="plain"
                  hide-details
                  readonly
                  persistent-placeholder
                  v-model="selected_article.sap_article_code">
                <template #label>
                  <span class="sm-bold text-primary">{{ $store.getters.translate('sap_article_code') }}</span>
                </template>
              </v-text-field>
              <v-text-field
                  density="default"
                  color="primary"
                  class="reg-normal mt-3"
                  variant="plain"
                  hide-details
                  readonly
                  persistent-placeholder
                  v-model="selected_article.replacement_article_code">
                <template #label>
                  <span class="sm-bold text-primary">{{ $store.getters.translate('replacement_article_code') }}</span>
                </template>
              </v-text-field>
              <v-text-field
                  density="default"
                  color="primary"
                  class="reg-normal mt-3"
                  variant="plain"
                  hide-details
                  readonly
                  persistent-placeholder
                  v-model="selected_article.phase_type">
                <template #label>
                  <span class="sm-bold text-primary">{{ $store.getters.translate('phase_type') }}</span>
                </template>
              </v-text-field>
              <div class="mt-3" style="display: flex;">
                <PhCheck v-if="selected_article.ce_marking" color="green" size="30"/>
                <PhX v-else color="red" size="30"/>
                <span class="pl-3 sm-normal" style="display: block; align-content: center;">{{ $store.getters.translate('ce_marking') }}</span>
              </div>
              <v-text-field
                  v-if="inspection_certificate"
                  density="default"
                  color="primary"
                  class="reg-normal mt-3"
                  variant="plain"
                  hide-details
                  readonly
                  persistent-placeholder
                  v-model="inspection_certificate.full_name">
                <template #label>
                  <span class="sm-bold text-primary">{{ $store.getters.translate('inspection_certificate_name') }}</span>
                </template>
              </v-text-field>
              <v-row class="mt-0" v-if="certificate_files.length > 0">
                <v-col>
                  <base-list-files
                      :page="page"
                      :parent_id="inspection_certificate.id"
                      :label="$store.getters.translate('certificate_files').toUpperCase()"
                      :files="certificate_files"
                      :multiple_files="true"
                      :deletable="false"
                      :create="false"/>
                </v-col>
              </v-row>
              <v-row class="mt-0" v-if="selected_article.defects.length > 0">
                <v-col>
                  <v-toolbar flat color="white" density="compact">
                    <v-toolbar-title class="text-primary">{{ $store.getters.translate('defects').toUpperCase() }}</v-toolbar-title>
                  </v-toolbar>
                  <v-list density="compact">
                    <v-list-item v-for="(defect, index) in selected_article.defects" :key="index" color="primary">
                      <v-list-item-title style="white-space: unset !important">
                        <a class="sm-bold" :href="'/defects/' + defect.id" target="_blank">{{ defect.short_name }}</a>
                      </v-list-item-title>
                      <v-list-item-subtitle class="no-webkit-line-clamp">
                        <span class="tiny-normal">{{ defect.deviations_and_remarks }}</span>
                      </v-list-item-subtitle>
                    </v-list-item>
                  </v-list>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </template>
      </BaseResizableColumns>
    </v-card-text>
  </v-card>
</template>

<script>
import { useAbility } from '@casl/vue';
import helpFunctions from "../../plugins/helpFunctions.js";
import BaseActionButton from "./BaseActionButton";
import BaseLinkButton from "./BaseLinkButton";
import BaseListFiles from "./BaseListFiles";
import BaseResizableColumns from "./BaseResizableColumns";
import {PhDotsThreeVertical, PhTrash, PhArrowSquareOut, PhGear, PhPlus, PhCheck, PhX} from "@phosphor-icons/vue";
import { Draggable, OpenIcon, dragContext } from '@he-tree/vue';
import '@he-tree/vue/style/default.css';
import '@he-tree/vue/style/material-design.css';

export default {
  components: {
    BaseResizableColumns,
    BaseListFiles,
    BaseLinkButton,
    BaseActionButton,
    Draggable,
    OpenIcon,
    PhX, PhCheck, PhPlus, PhGear, PhDotsThreeVertical, PhTrash, PhArrowSquareOut,
  },
  setup() {
    const { can } = useAbility()
    return { can }
  },
  data() {
    return {
      page: helpFunctions.pages.articles,
      all_records: [],
      records: [],
      advanced_search: {
        text_search: null,
        root_asset_name: null,
      },
      advanced_search_models: {
        root_asset_name: [],
      },
      selected_article: null,
      inspection_certificate: null,
      certificate_files: [],
      equipment_type_name: null,
      line_voltage_name: null,
    };
  },
  methods: {
    fillAdvancedSearchArrays() {
      this.all_records.forEach(record => {
        if(record.root_asset_name && !this.advanced_search_models.root_asset_name.includes(record.root_asset_name)) {
          this.advanced_search_models.root_asset_name.push(record.root_asset_name);
        }
      });
      this.showRecords();
    },
    showRecords() {
      let sorted_array = this.all_records;
      if(this.advanced_search.root_asset_name) {
        sorted_array = sorted_array.filter(item => item.root_asset_name === this.advanced_search.root_asset_name);
      }
      if(this.advanced_search.text_search) {
        sorted_array = sorted_array.filter(item => (item.tag_number_name && item.tag_number_name.toLowerCase().includes(this.advanced_search.text_search.toLowerCase())) ||
            (item.serial_number && item.serial_number.toLowerCase().includes(this.advanced_search.text_search.toLowerCase())) ||
            (item.type && item.type.toLowerCase().includes(this.advanced_search.text_search.toLowerCase())) ||
            (item.brand_name && item.brand_name.toLowerCase().includes(this.advanced_search.text_search.toLowerCase())) ||
            (item.location_name && item.location_name.toLowerCase().includes(this.advanced_search.text_search.toLowerCase())));
      }

      let temp_records = [];

      for (let i = 0; i < sorted_array.length; i++) {
        if (!temp_records[sorted_array[i].root_asset_name]) {
          temp_records[sorted_array[i].root_asset_name] = {
            id: "asset-" + sorted_array[i].root_asset_id,
            name: sorted_array[i].root_asset_name,
            type: "asset",
            children: []
          };
        }

        if (!temp_records[sorted_array[i].root_asset_name].children[sorted_array[i].location_name]) {
          temp_records[sorted_array[i].root_asset_name].children[sorted_array[i].location_name] = {
            id: "location-" + sorted_array[i].location_id,
            name: sorted_array[i].location_name,
            type: "location",
            children: []
          };
        }

        if (!temp_records[sorted_array[i].root_asset_name].children[sorted_array[i].location_name].children[sorted_array[i].tag_number_name]) {
          temp_records[sorted_array[i].root_asset_name].children[sorted_array[i].location_name].children[sorted_array[i].tag_number_name] = {
            id: "tagnumber-" + sorted_array[i].tag_number_id,
            name: sorted_array[i].tag_number_name,
            type: "tagnumber",
            children: []
          };
        }

        temp_records[sorted_array[i].root_asset_name].children[sorted_array[i].location_name].children[sorted_array[i].tag_number_name].children.push({
          id: "article-" + sorted_array[i].id,
          name: sorted_array[i].name,
          type: "article",
        });
      }

      this.records = Object.values(temp_records);

      for (let i = 0; i < this.records.length; i++) {
        this.records[i].children = Object.values(this.records[i].children);
        for (let x = 0; x < this.records[i].children.length; x++) {
          this.records[i].children[x].children = Object.values(this.records[i].children[x].children);
        }
      }
    },
    async endDrag() {
      if(dragContext.startInfo.parent.data.id !== dragContext.targetInfo.parent.data.id) {
        let payload = {
          article_id: dragContext.startInfo.dragNode.data.id.replace("article-", ""),
          tag_number_id: dragContext.targetInfo.parent.data.id.replace("tagnumber-", ""),
        };
        await helpFunctions.postCustomRoute(this.$toast, "move-article", payload, true, true);
      }
    },
    async getArticleInfo(id) {
      if(id.includes("article-")) {
        let model_id = id.replace("article-", "");
        if(!this.selected_article || this.selected_article.id !== model_id) {
          this.selected_article = await helpFunctions.loadModel(this.$toast, this.page.name, model_id);
          if(this.selected_article.equipment_type) {
            this.equipment_type_name = this.$store.getters.translate(this.selected_article.equipment_type.name);
          }
          if(this.selected_article.line_voltage) {
            this.line_voltage_name = this.selected_article.line_voltage.voltage + " " + this.selected_article.line_voltage.ac_dc;
          }

          if(this.selected_article.defects) {
            this.selected_article.defects.forEach(defect => {
              defect.short_name = "Distr. device function: " + this.$store.getters.translate(defect.distribution_device_function_name);
              if (defect.distribution_panel_name) {
                defect.short_name += ", panel: " + defect.distribution_panel_name;
              }
              if (defect.circuit_number) {
                defect.short_name += ", circuit number: " + defect.circuit_number;
              }
              if (defect.drawing_number) {
                defect.short_name += ", drawing number: " + defect.drawing_number;
              }
            });
          }

          await this.getInspectionCertificateInfo();
        }
      }
    },
    async getInspectionCertificateInfo() {
      this.certificate_files = [];
      if(this.selected_article.inspection_certificate_id) {
        this.inspection_certificate = await helpFunctions.getOneFullAdditionalModel(this.$toast, "inspectioncertificate", this.selected_article.inspection_certificate_id, true);
        if (this.inspection_certificate.files && this.inspection_certificate.files.length > 0) {
          this.inspection_certificate.files.forEach((file) => {
            if (file.revision === this.selected_article.inspection_certificate_revision) {
              this.certificate_files.push(file);
            }
          });
        }
      }
      else {
        this.inspection_certificate = null;
      }
    },
    async archive(item) {
      this.$confirm(this.$store.getters.translate("delete_confirmation")).then(async (res) => {
        if (res) {
          let model_id = item.id.replace("article-", "");
          await helpFunctions.deleteModel(this.$toast, this.page.name, model_id);
          this.selected_article = null;
          this.$emit('refresh');
        }
      });
    },
    clearSearch(key) {
      this.advanced_search[key] = null;
      this.showRecords();
    },
  },
  computed: {
    canCreate() {
      return this.can("create", this.$createEntity(this.page.model.toLowerCase(), { id: 0 }));
    },
    canDelete() {
      return this.can("delete", this.$createEntity(this.page.model.toLowerCase(), { id: 0 }));
    },
    canShowEquipmentTypes() {
      return this.can("show", this.$createEntity('equipmenttype', { id: 0 }));
    },
  },
};
</script>

<style scoped>
.chip-container {
  display: flex;
  gap: 8px;
  margin-right: 16px;
}
.he-tree__open-icon {
  font-size: 24px;
  width: 24px;
  height: 24px;
}
.active-highlight {
  background-color: #e0f7fa;
  border-radius: 5px;
}
.no-webkit-line-clamp {
  -webkit-line-clamp: unset !important;
}
</style>